// extracted by mini-css-extract-plugin
module.exports = {"lia-lock-icon":"NodeTitle_lia-lock-icon__FGMrv","lia-title-and-icon":"NodeTitle_lia-title-and-icon__wEuTM"};